(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_tabs"] && !Shopify.designMode) return;
  try {
    class TabsContainer {
    constructor(element) {
      this.element = element;
      this.style = element.dataset.tabStyle;
      this.tabs = element.querySelectorAll('.tabs-chip');
      this.panels = element.querySelectorAll('.tabs-content__panel');
      this.navigation = element.querySelector('.tabs-navigation');

      this.init();
    }

    init() {
      // Set up data attributes and initial active state for panels
      this.panels.forEach((panel, index) => {
        panel.dataset.tabIndex = index;
        if (index === 0) {
          panel.classList.add('tabs-content__panel--active');
        }
      });

      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => this.handleTabClick(tab));
      });

      if (this.style === 'scroll') {
        this.initScrollObserver();
      }
    }

    handleTabClick(tab) {
      const index = parseInt(tab.dataset.tabIndex, 10);

      if (this.style === 'normal') {
        // Normal tabs: switch active panel
        this.tabs.forEach(t => t.classList.remove('tabs-chip--active'));
        this.panels.forEach(p => p.classList.remove('tabs-content__panel--active'));

        tab.classList.add('tabs-chip--active');
        if (this.panels[index]) {
          this.panels[index].classList.add('tabs-content__panel--active');
        }
      } else {
        // Scroll tabs: scroll to panel
        if (this.panels[index]) {
          this.panels[index].scrollIntoView({ behavior: 'smooth' });
        }
      }
    }

    initScrollObserver() {
      const observerOptions = {
        root: null,
        rootMargin: '-50% 0px -50% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.tabIndex, 10);
            this.setActiveTab(index);
          }
        });
      }, observerOptions);

      this.panels.forEach(panel => observer.observe(panel));
    }

    setActiveTab(index) {
      this.tabs.forEach(t => t.classList.remove('tabs-chip--active'));
      const activeTab = this.tabs[index];
      if (activeTab) {
        activeTab.classList.add('tabs-chip--active');

        // Scroll chip into view if needed
        activeTab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
  }

  document.querySelectorAll('.tabs-container').forEach(el => new TabsContainer(el));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_timer"] && !Shopify.designMode) return;
  try {
    class CountdownTimer {
    constructor(element) {
      this.element = element;
      this.endDate = element.dataset.endDate;
      this.endTime = element.dataset.endTime || '00:00';

      this.daysEl = element.querySelector('.countdown-timer__days');
      this.hoursEl = element.querySelector('.countdown-timer__hours');
      this.minutesEl = element.querySelector('.countdown-timer__minutes');
      this.secondsEl = element.querySelector('.countdown-timer__seconds');

      this.init();
    }

    init() {
      if (!this.endDate) return;

      this.targetDate = new Date(`${this.endDate}T${this.endTime}:00`);
      this.update();
      this.interval = setInterval(() => this.update(), 1000);
    }

    update() {
      const now = new Date();
      const diff = this.targetDate - now;

      if (diff <= 0) {
        this.daysEl.textContent = '00';
        this.hoursEl.textContent = '00';
        this.minutesEl.textContent = '00';
        this.secondsEl.textContent = '00';
        this.element.classList.add('countdown-timer--expired');
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      this.daysEl.textContent = String(days).padStart(2, '0');
      this.hoursEl.textContent = String(hours).padStart(2, '0');
      this.minutesEl.textContent = String(minutes).padStart(2, '0');
      this.secondsEl.textContent = String(seconds).padStart(2, '0');
    }
  }

  document.querySelectorAll('.countdown-timer').forEach(el => new CountdownTimer(el));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["brand-navigation"] && !Shopify.designMode) return;
  try {
    /**
   * 알파벳 내비게이션 클릭 시 URL 해시(#brand-a) 없이 해당 그룹으로 스크롤한다.
   * 오프셋은 .brand-list__group 의 scroll-margin-top(헤더 높이 보정)을 그대로 재사용한다.
   */
  (() => {
    if (window.brandNavigationScrollBound) return;
    window.brandNavigationScrollBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.brand-navigation__item[data-target]');
      if (!trigger) return;

      const target = document.getElementById(trigger.dataset.target);
      if (!target) return;

      const offset = parseFloat(window.getComputedStyle(target).scrollMarginTop) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["piyonna-carousel"] && !Shopify.designMode) return;
  try {
    class PiyonnaCarouselComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.startX = 0;
      this.currentX = 0;
      this.isDragging = false;
    }

    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      this.slides = this.querySelectorAll('.piyonna-carousel__slide');
      this.slideCount = parseInt(this.dataset.slideCount) || this.slides.length;
      this.viewport = parseFloat(this.dataset.viewport) || 1.3;

      this.bindEvents();
    }

    bindEvents() {
      this.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: true });
      this.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      this.addEventListener('touchend', this.handleTouchEnd.bind(this));

      this.addEventListener('mousedown', this.handleMouseDown.bind(this));
      this.addEventListener('mousemove', this.handleMouseMove.bind(this));
      this.addEventListener('mouseup', this.handleMouseUp.bind(this));
      this.addEventListener('mouseleave', this.handleMouseUp.bind(this));
    }

    getSlideWidth() {
      return this.offsetWidth / this.viewport;
    }

    handleTouchStart(e) {
      this.startX = e.touches[0].clientX;
      this.isDragging = true;
      this.track.style.transition = 'none';
    }

    handleTouchMove(e) {
      if (!this.isDragging) return;
      e.preventDefault();
      this.currentX = e.touches[0].clientX;
      const diff = this.currentX - this.startX;
      const currentOffset = -this.currentIndex * this.getSlideWidth();
      this.track.style.transform = `translateX(${currentOffset + diff}px)`;
    }

    handleTouchEnd() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = 'transform 0.3s ease-out';

      const diff = this.currentX - this.startX;
      const threshold = this.getSlideWidth() * 0.2;

      if (Math.abs(diff) > threshold) {
        if (diff < 0 && this.currentIndex < this.slideCount - 1) {
          this.currentIndex++;
        } else if (diff > 0 && this.currentIndex > 0) {
          this.currentIndex--;
        }
      }

      this.goToSlide(this.currentIndex);
    }

    handleMouseDown(e) {
      this.startX = e.clientX;
      this.isDragging = true;
      this.track.style.transition = 'none';
      this.style.cursor = 'grabbing';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;
      this.currentX = e.clientX;
      const diff = this.currentX - this.startX;
      const currentOffset = -this.currentIndex * this.getSlideWidth();
      this.track.style.transform = `translateX(${currentOffset + diff}px)`;
    }

    handleMouseUp() {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = 'transform 0.3s ease-out';
      this.style.cursor = '';

      const diff = this.currentX - this.startX;
      const threshold = this.getSlideWidth() * 0.2;

      if (Math.abs(diff) > threshold) {
        if (diff < 0 && this.currentIndex < this.slideCount - 1) {
          this.currentIndex++;
        } else if (diff > 0 && this.currentIndex > 0) {
          this.currentIndex--;
        }
      }

      this.goToSlide(this.currentIndex);
    }

    goToSlide(index) {
      this.currentIndex = Math.max(0, Math.min(index, this.slideCount - 1));
      const offset = -this.currentIndex * this.getSlideWidth();
      this.track.style.transform = `translateX(${offset}px)`;
    }
  }

  if (!customElements.get('piyonna-carousel-component')) {
    customElements.define('piyonna-carousel-component', PiyonnaCarouselComponent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-carousel"] && !Shopify.designMode) return;
  try {
    class ProductCarouselComponent extends HTMLElement {
    connectedCallback() {
      this.container = this.querySelector('.product-carousel__container');
      this.prevBtn = this.querySelector('.product-carousel__nav--prev');
      this.nextBtn = this.querySelector('.product-carousel__nav--next');

      // vendor(동일 브랜드)/category(동일 카테고리) 모드: /search 인덱스에서 클라이언트로 가져온다
      const remoteFetchUrl = this.dataset.vendorFetchUrl || this.dataset.categoryFetchUrl;
      if (remoteFetchUrl) {
        this.loadRemoteProducts(remoteFetchUrl);
        return;
      }

      this.init();
    }

    init() {
      this.sortSlides();

      if (!this.container) return;

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => this.scroll('prev'));
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => this.scroll('next'));
      }

      this.container.addEventListener('scroll', () => this.updateNavVisibility());
      this.updateNavVisibility();

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => this.updateNavVisibility());
        this.resizeObserver.observe(this.container);
      }
    }

    async loadRemoteProducts(fetchUrl) {
      const carousel = this.closest('.product-carousel');
      const track = this.querySelector('.product-carousel__track');
      const minSlides = parseInt(this.dataset.minSlides) || 5;
      const currentId = this.dataset.currentProductId;

      try {
        const res = await fetch(fetchUrl);
        if (!res.ok) throw new Error('Server returned ' + res.status);

        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        let slides = Array.from(doc.querySelectorAll('.product-carousel__slide'));

        // 현재 보고 있는 상품은 제외
        if (currentId) {
          slides = slides.filter((slide) => slide.dataset.productId !== currentId);
        }

        if (!track || slides.length < minSlides) {
          carousel?.remove();
          return;
        }

        // category 모드: 가져온 전체를 랜덤 셔플 후, 리뷰가 약한 상품(리뷰 0개 또는 평점 3점 미만)을
        // 뒤로 보낸 다음 앞에서 20개를 고른다. (sort_by 설정과 무관하게 항상 이 정렬을 적용)
        const isCategory = !!this.dataset.categoryFetchUrl;
        if (isCategory) {
          slides = this.sortCategorySlides(slides);
        }

        // 최대 20개만 렌더, 20개 초과일 때만 더보기 버튼 유지
        const overflow = slides.length > 20;
        slides = slides.slice(0, 20);

        slides.forEach((slide) => track.appendChild(slide));
        this.dataset.slideCount = String(slides.length);
        carousel?.classList.remove('product-carousel--pending');
        if (!overflow) {
          carousel?.querySelector('.product-carousel__footer')?.remove();
        }
        // category 모드는 이미 정렬을 마쳤으므로 init 내부 sortSlides 가 재정렬하지 않도록 막고,
        // 트래킹 index 만 표시 순서에 맞춰 동기화한다
        if (isCategory) {
          this.dataset.sortBy = 'collection_order';
          this.updateTrackingIndices(track);
        }
        this.init();
      } catch (e) {
        console.error('Product carousel remote fetch error:', e.message);
        carousel?.remove();
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
    }

    sortSlides() {
      const sortBy = this.dataset.sortBy;
      if (!sortBy || sortBy === 'default' || sortBy === 'collection_order') return;

      const track = this.querySelector('.product-carousel__track');
      if (!track) return;

      const slides = Array.from(track.querySelectorAll('.product-carousel__slide'));
      if (slides.length <= 1) return;

      if (sortBy === 'random') {
        for (let i = slides.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          const temp = slides[i];
          slides[i] = slides[j];
          slides[j] = temp;
        }
      } else {
        slides.sort((a, b) => {
          if (sortBy === 'review_count') {
            return (parseInt(b.dataset.reviewCount) || 0) - (parseInt(a.dataset.reviewCount) || 0);
          } else if (sortBy === 'price_desc') {
            return (parseInt(b.dataset.price) || 0) - (parseInt(a.dataset.price) || 0);
          } else if (sortBy === 'price_asc') {
            return (parseInt(a.dataset.price) || 0) - (parseInt(b.dataset.price) || 0);
          }
          return 0;
        });
      }

      slides.forEach((slide) => track.appendChild(slide));

      this.updateTrackingIndices(track);
    }

    // category 모드 전용 정렬: 전체 랜덤 셔플 → 리뷰 약한 상품(리뷰 0개 또는 평점 3점 미만)을 뒤로
    // 각 그룹(정상/약함)은 셔플된 순서를 유지한다
    sortCategorySlides(slides) {
      const shuffled = slides.slice();
      for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = shuffled[i];
        shuffled[i] = shuffled[j];
        shuffled[j] = temp;
      }

      const isWeak = (slide) => {
        const reviewCount = parseInt(slide.dataset.reviewCount) || 0;
        const rating = parseFloat(slide.dataset.rating) || 0;
        return reviewCount === 0 || rating < 3;
      };

      const strong = shuffled.filter((slide) => !isWeak(slide));
      const weak = shuffled.filter((slide) => isWeak(slide));
      return strong.concat(weak);
    }

    // DOM 정렬 후 index를 표시 순서로 동기화 (트래킹 정확도)
    // 트래킹 속성은 슬라이드 내부 product-card-v2 엘리먼트에 위치
    updateTrackingIndices(track) {
      if (!track) return;
      track.querySelectorAll('.product-carousel__slide').forEach((slide, i) => {
        const card = slide.querySelector('[data-gb-props-view], [data-gb-props-click], [data-gb-props]');
        if (!card) return;
        ['data-gb-props-view', 'data-gb-props-click', 'data-gb-props'].forEach((attr) => {
          const raw = card.getAttribute(attr);
          if (!raw) return;
          try {
            const obj = JSON.parse(raw);
            obj.index = i + 1;
            card.setAttribute(attr, JSON.stringify(obj));
          } catch (e) {}
        });
      });
    }

    scroll(direction) {
      const cs = this.container;
      if (!cs) return;
      const slides = Array.from(this.querySelectorAll('.product-carousel__slide'));
      if (!slides.length) return;

      const csRect = cs.getBoundingClientRect();
      const style = getComputedStyle(cs);
      const padLeft = parseFloat(style.paddingLeft) || 0;
      const padRight = parseFloat(style.paddingRight) || 0;
      const leftEdge = csRect.left + padLeft;
      const rightEdge = csRect.right - padRight;
      const TOL = 1;

      if (direction === 'next') {
        // 오른쪽으로 완전히 가려져 있던 '다음' 상품을 맨 왼쪽으로 정렬
        const target = slides.find((s) => s.getBoundingClientRect().left >= rightEdge - TOL);
        if (target) {
          cs.scrollBy({ left: target.getBoundingClientRect().left - leftEdge, behavior: 'smooth' });
        } else {
          cs.scrollTo({ left: cs.scrollWidth, behavior: 'smooth' });
        }
      } else {
        // 왼쪽으로 완전히 가려진 마지막 상품을 맨 오른쪽에 맞춰 한 페이지 뒤로
        const hidden = slides.filter((s) => s.getBoundingClientRect().right <= leftEdge + TOL);
        const target = hidden[hidden.length - 1];
        if (target) {
          cs.scrollBy({ left: target.getBoundingClientRect().right - rightEdge, behavior: 'smooth' });
        } else {
          cs.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
    }

    updateNavVisibility() {
      if (!this.prevBtn || !this.nextBtn) return;
      const { scrollLeft, scrollWidth, clientWidth } = this.container;
      const atStart = scrollLeft <= 0;
      const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

      this.prevBtn.classList.toggle('product-carousel__nav--hidden', atStart);
      this.nextBtn.classList.toggle('product-carousel__nav--hidden', atEnd);

      const leftGrad = this.querySelector('.product-carousel__gradient--left');
      const rightGrad = this.querySelector('.product-carousel__gradient--right');
      if (leftGrad) leftGrad.classList.toggle('product-carousel__gradient--hidden', atStart);
      if (rightGrad) rightGrad.classList.toggle('product-carousel__gradient--hidden', atEnd);
    }
  }

  if (!customElements.get('product-carousel-component')) {
    customElements.define('product-carousel-component', ProductCarouselComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
